import { useEffect } from "react";
import Container from "@mui/material/Container";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { formatISO } from "date-fns";
import { getEmpresasByCuentaContrato } from "component/api";
//import "./css/Print.css";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "valeInfoContent",
  },
  dataLayerName: "Vales",
};

const ValeInfoContent = (props) => {
  TagManager.dataLayer(tagManagerArgs);

  const qr = null || props.qr || localStorage.getItem("qr");

  const cuentaContrato = localStorage.getItem("cuentaContrato");
  const empresaNombre = localStorage.getItem("empresaNombre");
  const vale = localStorage.getItem("valeType");

  async function getEmpresasByCuentaContratoFunc(cc) {
    await getEmpresasByCuentaContrato(cc);
  }

  const idvale = localStorage.getItem("idvale");

  function valem3() {
    if (vale == 1) {
      return 12;
    }
    if (vale == 2) {
      return 20;
    }
    if (vale == 3) {
      return 36;
    }
  }
  function valeId() {
    return idvale;
  }
  function valeIdText() {
    if (idvale != null) {
      return <p> ID DE VALE : {idvale}</p>;
    }

    if (idvale == null) {
      return null;
    }
  }

  const fechaInicio = formatISO(new Date(), {
    representation: "date",
  });

  useEffect(() => {
    try {
      valeId();
      valeIdText();
      console.log("idvale " + idvale);
      getEmpresasByCuentaContratoFunc(cuentaContrato);
    } catch (err) {}
  }, [idvale]);

  const baseUrl = window.location.host;

  const valeInfo = (
    <Container maxWidth="md">
      <Container
        maxWidth="70%"
        style={{
          marginTop: "4%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignSelf: "center",
        }}
      >
        <div
          style={{
            border: "black 1px ridge",
            width: "100%",
            alignSelf: "center",
          }}
        >
          <Container
            maxWidth="md"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignSelf: "center",
            }}
          >
            <br />
            <p style={{ alignSelf: "center", marginTop: "1%" }}>
              NOMBRE Y APELLIDO/EMPRESA: {empresaNombre}
              <br />
              NÚMERO DE CUENTA: {cuentaContrato}
              <br />
              {valeIdText()}
              FECHA: {fechaInicio}
            </p>
            <div
              style={{
                border: " solid #1E90FF ",
                marginRight: "10%",
                marginLeft: "10%",
                marginBottom: "10%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  style={{
                    margin: "3%",
                    alignSelf: "center",
                  }}
                  src="https://www.aysa.com.ar/assets/Menu/img/logo.png"
                  alt="aysa logo"
                />
              </div>
              <div
                style={{
                  backgroundColor: "#B0E0E6",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <h1 style={{ alignSelf: "center", marginBottom: "-2%" }}>
                  Vale descarga
                </h1>
                <h2 style={{ alignSelf: "center", color: "#1E90FF " }}>
                  Hasta {valem3()} m3
                </h2>
                {qr == true && (
                  <Link
                    to={`/backoffice/vaciadero?idvale=${idvale}`}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <QRCodeSVG
                      bgColor="#FFFFFF"
                      fgColor="#000000"
                      level="Q"
                      style={{ maxWidth: 150, alignSelf: "center" }}
                      value={`${baseUrl}/backoffice/vaciadero?idvale=${idvale}`}
                    />
                  </Link>
                )}

                <br />
                <div style={{ alignSelf: "center" }}>{valeId()}</div>
              </div>
            </div>

            <br />
          </Container>
        </div>

        <br />
      </Container>
    </Container>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div>{valeInfo}</div>
      <br />
    </div>
  );
};

export default ValeInfoContent;
